import apiConfig from '../../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const getUrlResults = async (userId) => {
  try {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(`${api_base_url}/api/${api_key}/get/${userId}/gcp/urlResults`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
    });
  
    return response.json();
  } catch (error) {
    console.error('Error fetching user url details:', error);
    throw error;
  }
};
